<template>
  <div class="view__view view-privacy">
    <div class="view__headline">
      <span class="heading beta -color-white">Wir nehmen Datenschutz ernst</span>
    </div>
    <div class="view__form form">
      <div class="field__wrap l-2col-50-50">
        <label for="privacy" class="checkbox" :class="{'-filled': privacy}">
          <input type="checkbox" id="privacy" @change="privacy = !privacy">
          <span class="-color-white">Mit setzen des Hakens erkläre ich mich einverstanden,
            dass die von mir erhobenen Daten für die Bearbeitung meiner
            Anfrage elektronisch erhoben und gespeichert werden. Diese
            Einwilligung kann jederzeit mit einer Nachricht an uns widerrufen werden.
            Weitere Informationen entnehmen Sie der <a
              href="/datenschutz" target="_blank">Datenschutzerklärung</a>.</span>
        </label>

      </div>
    </div>
    <div class="cta-wrapper">
      <button class="-btn-beta" @click="handleSubmit"><span>Reklamation absenden</span></button>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/user';
import { useViewStore } from '@/stores/view';

export default {
  name: 'PrivacyEntry',
  data() {
    return {
      privacy: false,
    };
  },
  methods: {
    handleSubmit() {
      if (this.privacy) {
        this.$emit('sendRequest');
      }
    },
  },
  setup() {
    const user = useUserStore();
    const view = useViewStore();
    return {
      user,
      view,
    };
  },
};
</script>
